import { Component } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[Tentacles] Render error captured by boundary:", error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.assign("/");
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        data-testid="error-boundary-fallback"
        className="min-h-screen flex items-center justify-center bg-nexus-bg text-nexus-text px-6"
      >
        <div className="relative brackets border border-nexus-border bg-nexus-panel/40 max-w-lg w-full p-8">
          <span className="b1" /><span className="b2" />
          <div className="flex items-center gap-3 text-nexus-rose">
            <AlertTriangle size={22} />
            <span className="font-mono text-[11px] uppercase tracking-[0.3em]">System Fault</span>
          </div>
          <h1 className="font-rajdhani font-bold text-2xl tracking-tight mt-4">
            The console hit an unexpected error
          </h1>
          <p className="text-nexus-text-2 text-sm mt-2 leading-relaxed">
            A view failed to render. Your session is still active — reload the command center to continue your investigation.
          </p>
          {this.state.error?.message && (
            <pre
              data-testid="error-boundary-message"
              className="mt-4 text-[11px] font-mono text-nexus-text-3 bg-nexus-bg/60 border border-nexus-border p-3 overflow-auto max-h-32"
            >
              {String(this.state.error.message)}
            </pre>
          )}
          <button
            data-testid="error-boundary-reset"
            onClick={this.handleReset}
            className="mt-6 inline-flex items-center gap-2 border border-nexus-cyan text-nexus-cyan px-4 py-2 text-[11px] font-mono uppercase tracking-widest hover:bg-nexus-cyan/10 transition-colors"
          >
            <RotateCcw size={13} /> Reload Command Center
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
